/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DatabaseBackgroundImageSettings
 */
export interface DatabaseBackgroundImageSettings {
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseBackgroundImageSettings
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DatabaseBackgroundImageSettings
     */
    fileRef?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseBackgroundImageSettings
     */
    tiled?: boolean;
}

/**
 * Check if a given object implements the DatabaseBackgroundImageSettings interface.
 */
export function instanceOfDatabaseBackgroundImageSettings(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseBackgroundImageSettingsFromJSON(json: any): DatabaseBackgroundImageSettings {
    return DatabaseBackgroundImageSettingsFromJSONTyped(json, false);
}

export function DatabaseBackgroundImageSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseBackgroundImageSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'fileRef': !exists(json, 'fileRef') ? undefined : json['fileRef'],
        'tiled': !exists(json, 'tiled') ? undefined : json['tiled'],
    };
}

export function DatabaseBackgroundImageSettingsToJSON(value?: DatabaseBackgroundImageSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'fileRef': value.fileRef,
        'tiled': value.tiled,
    };
}

